{
    "appTitle": "Cleanfix connect",
    "settings": {
        "inquiries_new_receive_notifications": "Notify me when an inquiry is submitted"
    }
}
